import { useState, useEffect } from "react";
import { addCommas } from "@persian-tools/persian-tools";
import "./product.scss";
import { NavLink } from "react-router-dom";
import newLogo from "assets/images/Logos/newLogo.jpeg";
const Product = ({
  title = true,
  dis = false,
  // image = true,
  link = "/",
  price = true,
  maker = true,
  star = true,
  data,
}) => {
  console.log("data***", data);
  return (
    <div className="col-6 col-md-4 col-lg-3">
      {" "}
      <div className="Product  px-2">
        <NavLink to={`/product/${data.id}`}>
          <div className="bg-light item text-center p-2 mx-auto">
            <img
              className="img-product"
              src={
                data.image == undefined || data.image == ""
                  ? newLogo
                  : "http://grc.tatdemo.ir/" + data.image
              }
              width={195}
              // height={195}
              // height={100}
              alt
            />
            <div className="bg-white item-title w-100 p-2 mt-3">
              <div className="p-1">
                <div className="main-text2">
                  <p
                    className="text-color text-center"
                    style={{ fontSize: 14 }}
                  >
                    {title && <p>{data.name}</p>}
                  </p>
                </div>
              </div>
              {dis && (
                <div className="p-4">
                  <div className="main-text">
                    <p
                      className="text-color text-center "
                      style={{ fontSize: 14 }}
                    >
                      {data.dis}
                    </p>
                  </div>
                </div>
              )}
              <div className=" d-flex flex-row justify-content-between brand-star">
                {maker && <p className="text-secondary">{data.brand}</p>}
                <div className=" d-flex flex-row">
                  {star && (
                    <>
                      <small className="pt-1 text-secondary">
                        ({data.score_count})
                      </small>
                      <p className="mx-1 text-secondary">{data.score}</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={19}
                        height={21}
                        viewBox="0 0 19 21"
                      >
                        <path
                          id="Icon_awesome-star"
                          data-name="Icon awesome-star"
                          d="M9.922.73,7.6,6.159l-5.189.874a1.374,1.374,0,0,0-.629,2.239L5.54,13.5l-.888,5.967c-.16,1.079.824,1.886,1.648,1.382l4.642-2.817,4.642,2.817c.824.5,1.808-.3,1.648-1.382L16.343,13.5,20.1,9.272a1.374,1.374,0,0,0-.629-2.239L14.28,6.159,11.961.73a1.076,1.076,0,0,0-2.039,0Z"
                          transform="translate(-1.441 0.001)"
                          fill="#eca72c"
                        />
                      </svg>
                    </>
                  )}
                </div>
              </div>
              <div className=" text-end">
                {data.discount != "0" ? (
                  <>
                    <p className="text-danger text-decoration-line-through mb-1 fs-12">
                      {addCommas(data.price)}
                    </p>
                    <p className=" text-secondary mt-0 pt-0 fs-14">
                      {addCommas(+data.price - +data.discount)}تومان
                    </p>
                    {/* <button className="btn btn-light eye-btn pt-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="eye-icon"
                        width="17.066"
                        height="10.5"
                        viewBox="0 0 17.066 11.5"
                      >
                        <path
                          id="Icon_ionic-md-eye"
                          data-name="Icon ionic-md-eye"
                          d="M10.783,7.383a9.176,9.176,0,0,0-8.533,5.75,9.207,9.207,0,0,0,17.066,0A9.176,9.176,0,0,0,10.783,7.383Zm0,9.585a3.835,3.835,0,1,1,3.878-3.835A3.867,3.867,0,0,1,10.783,16.967Zm0-6.135a2.3,2.3,0,1,0,2.328,2.3A2.321,2.321,0,0,0,10.783,10.833Z"
                          transform="translate(-2.25 -7.383)"
                          fill="#011c40"
                        />
                      </svg>
                    </button> */}
                  </>
                ) : (
                  <>
                    <p></p>
                    <p className="text-secondary fs-14">
                      {addCommas(data.price)} تومان
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </NavLink>
      </div>
    </div>
  );
};

export default Product;
